import styled from "styled-components";

const AcceptanceTermsEditorWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 24px;
    gap: 24px;
    border-radius: 8px;

    .editor {
        padding: 0 8px;
        height: 100%;
        max-height: 600px;
        min-height: 600px;
    }

    .editorToolbar {
        border: none;
        border-bottom: 1px solid #e0e0e0;
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.05);
        align-items: center;
        justify-content: center;
    }

    .editorWrapper {
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
        border: 1px solid #e0e0e0;
    }

    .editorToolbar a {
        text-decoration: none;
        color: #000;
    }

    .editorToolbar .rdw-option-wrapper {
        padding: 8px;
        height: 30px;
    }
`;

const AcceptanceTermsEditorButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
`;

export { AcceptanceTermsEditorWrapper, AcceptanceTermsEditorButtonWrapper };
